module.exports = __webpack_public_path__ + "img/chanpin_1@2x.f3c1a074.png";